
import { Component, Vue } from "vue-property-decorator";
import Api from "@/api/index.ts";
import { mapGetters } from "vuex";
import checkCouponOpened from "@/services/checkCouponOpened.ts";
import loadFonts from "@/services/loadFonts.ts";
const { detect } = require("detect-browser");

@Component({
  name: "App",
  computed: mapGetters("app", ["lang"])
})
export default class App extends Vue {
  created() {
    this.loadFont();
    this.initBrowser();
  }

  async loadFont() {
    await loadFonts();
    this.$store.dispatch("app/setFontLoad");
  }

  initBrowser() {
    const browser = detect();
    const isMojave = /Mac OS X 10[._]14/.test(navigator.userAgent);
    const html = document.getElementsByTagName("html")[0];
    html.classList.add(browser.name, browser.os.toLowerCase().split(" ")[0]);
    isMojave ? html.classList.add("mojave") : null;
  }
}
